import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationStateService {
    private readonly PREMATCH_NAV = 'PREMATCH_NAV';
    private readonly LIVE_NAV = 'LIVE_NAV';
    private currentRegisteredNavigation = '';

    setLeftNavigation(live: boolean): void {
        if (live) {
            this.currentRegisteredNavigation = this.LIVE_NAV;
        } else {
            this.currentRegisteredNavigation = this.PREMATCH_NAV;
        }
    }

    removeLeftNavigation(): void {
        this.currentRegisteredNavigation = '';
    }

    get isPrematchNavRegistered(): boolean {
        return this.currentRegisteredNavigation === this.PREMATCH_NAV;
    }

    get isLiveNavRegistered(): boolean {
        return this.currentRegisteredNavigation === this.LIVE_NAV;
    }
}
